import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client/core';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import { onError } from '@apollo/client/link/error';
import { graphqlUrl } from '@/env.js';
// Vuex
import store from '@/store';
// Vue-router
import router from '@/router';

const uploadLink = createUploadLink({
  uri: graphqlUrl,
  credentials: 'include',
});

// Configurar graphQL
const cache = new InMemoryCache();

const errorLink = onError(({ networkError }) => {
  if (networkError && networkError.statusCode === 401) {
    // Redirige o notifica al usuario que no está autenticado
    const nextUrl = window.location.pathname;
    // let nextPath = staticUrl;
    // if (nextUrl !== '/') {
    //   nextPath += `?next=${nextUrl}`;
    // }
    // Aquí puedes redirigir a la página de login o ejecutar otras acciones
    // console.log(nextPath);
    // window.location.href = nextPath;
    store.commit('auth/LOGOUT');
    const query = {};
    if (nextUrl !== '/') {
      query.next = nextUrl;
    }
    router.push({
      name: 'Login',
      query
    });
  }
});

export default new ApolloClient({
  cache,
  link: ApolloLink.from([errorLink, uploadLink]),
});
